module.exports = __webpack_public_path__ + "img/ca1890c7a774915b8fe445039fec3770.png";